import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { css } from "@emotion/react";
import { Drawer, CircularProgress } from "@mui/material";
import {showSuccessProjectPopupAtom} from "../Atoms";
import { useAtomValue } from "jotai";
import { useSelector } from "react-redux";
import { Icon, ICONS } from "@/modules/ui-elements/Icon";
import { uploadS3ForChat} from "@/modules/editor-v2/services/Listing";
import CustomizedButton from "src/modules/ui-elements/CustomizedButton";
import { Box } from "@mui/system";
import { updateInstruction} from '../services/Jobs';

export default function AddInstruction(props) {
    const isOpen = props?.isOpen;
    const scrollRef = useRef(null);
    const timerRef = useRef(null);
    const { openHandler, instructionHandler=()=>{} } = props;
    const [inputValue, setInputValue] = useState('');
    const [instuctionsArray, setInstuctionsArray] = useState([]);
    const getSuccessProjectValue = useAtomValue(showSuccessProjectPopupAtom);
    const {entireStrapiData} = useSelector(state=>state.strapi);
    const strapiData = entireStrapiData?.SendForProTouchBE?.SendForProTouchBE;
    const attachmentUploadRef = React.useRef(null);
    const [attachmentsSelected, setAttachmentsSelected] = useState([]);
    const [loadingAttachment, setLoadingAttachment] = useState(false);
    const [disableClick, setDisable] = useState(false);

    let styles = commonStyle(isOpen, inputValue);

    useEffect(()=>{
        styles = commonStyle(isOpen, inputValue) 
    }, [inputValue])

    const handleInputChange = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setInputValue(e.target.value);

    };

    const onInputChange = (event) => {
        event.target.value = null
    }
    
    const handleEnterKeyPress = (e) => {
      if(loadingAttachment || (attachmentsSelected?.length < 1 && inputValue?.trim()?.length < 1))return;
        if (e.key === 'Enter') {
          handleSubmit();
        }
    };

    const extractFileName = (url) => {
      const fullFileName = url.substring(url.lastIndexOf('/') + 1);
      return fullFileName.replace(/%20/g, ' ');
    };

    const handleSubmit = async () => {
      const instructionsData = [
        ...(inputValue?.trim()?.length > 0 ? [inputValue.trim()] : []),
        ...attachmentsSelected,
      ];
    
      const previousComment = [...instuctionsArray];
      setInstuctionsArray([...previousComment, ...instructionsData]);
    
      setInputValue('');
      setAttachmentsSelected([]);
    
      const jobIds = Array.isArray(props.jobId) ? props.jobId : [props.jobId];
      const jobIdsAsStrings = jobIds.map(jobId => jobId && jobId.job_id ? jobId.job_id : jobId);
    
      try {
        for (const jobId of jobIdsAsStrings) {
          const response = await updateInstruction(jobId, instructionsData);
          if (!response?.success) {
            console.error(`Failed to submit instructions for job ID: ${jobId}`);
          }
        }
      } catch (error) {
        console.error("Error while submitting instructions:", error);
      }
    
      timerRef.current = setTimeout(() => {
        if (scrollRef.current) {
          const { scrollHeight } = scrollRef.current;
          scrollRef.current.scrollTo({
            top: scrollHeight,
            behavior: 'smooth',
          });
        }
      }, 500);
    };
    

     const closeHandler = () =>{
        setInputValue(''); 
        openHandler();
        if (instuctionsArray.length>0) instructionHandler(instuctionsArray);
     }

     const onFileUpload = async (e) => {
        // if(!e.target.files?.length || props.disableClick) return;
        try{
            setLoadingAttachment(true)
            const formData = new FormData();
            formData.append("file",e.target.files?.[0])
            const res = await uploadS3ForChat(formData);
            if(res?.data?.data){
                setAttachmentsSelected(prev => [...prev, res?.data?.data])
            }
        }catch(error){
            console.log('error', error)
        }finally{
          setLoadingAttachment(false)
        }
    }

    const onAttachmentDeleteClick = async (item) => {
        if(disableClick) return;
        let myData = [...(attachmentsSelected || [])];
        const filteredData = myData?.filter((data)=> (data?.toLowerCase() !== item?.toLowerCase())) || [];
       
        // uniq([...filteredData]);
        setAttachmentsSelected(filteredData)
    }

     useEffect(() => {
          setInstuctionsArray([])
      }, [getSuccessProjectValue]);

    return (<Drawer
        open={isOpen}
        onClose={closeHandler}
        anchor="right"
      BackdropProps={{
        invisible: true, style: {
          backgroundColor: 'rgba(0, 0, 0, 0.6)', 
        },
      }}
        sx={{
          width: 378,
          zIndex: 1500,
          flexShrink: 0,
          right: isOpen ? 0 : 'unset',
          ".MuiDrawer-paper": {
            borderRadius: '8px 0px 0px 8px',
          }
        }}
      >
        {/* Top section - fixed, unaffected by scroll */}
        <div style={{ width: "368px", zIndex: "15600", background: "white", position: "sticky", top: 0 }}>
        <Box sx={{ cursor: 'pointer' }} onClick={closeHandler}><img src="/icons/close.svg" width="20px" /></Box>
          <div css={styles?.title}>
            {strapiData?.AddCommentText || `Add Comment`}
          </div>
          <div css={styles?.subtitle1}>
            {strapiData?.WouldYouLikeText || `Would you like to give any special instructions for these images`}
          </div>
        </div>
      
        
          <div ref={scrollRef} css={styles?.instructionsContainer}>
            {instuctionsArray?.length > 0 && (
              instuctionsArray.map((message, index) => (
                <div key={index} css={styles?.message}>
                   {message.startsWith('https://')
                    ? extractFileName(message)
                    : message}
                </div>
              ))
            )}
          </div>
      

        <div css={styles?.bottomContainer} style={{ flexGrow: 1 }}>
          <div style={{ width: "100%" }} className="button">
            <input
              css={styles?.input}
              type="text"
              value={inputValue}
              onChange={handleInputChange}
              onKeyDown={handleEnterKeyPress}
              placeholder={strapiData?.WriteAComment || "Write a comment..."}
              autoFocus
            />
          </div>
      
          <div style={{width: "100%" }}>
            {/* Attachment Section */}
            <div style={{ position: 'relative' }}>
              <div style={{ display: 'flex', justifyContent: 'center', background: '#EEEEEE', border: "1px solid #EEEEEE", borderRadius: 4, fontSize: 14, padding: 8, width: "100%" }}>
                {loadingAttachment ? <CircularProgress size={16} style={{ color: '#262626' }} /> :
                  <>
                    <Icon src={ICONS.attachmentIcon} height={20} width={20} />
                    Attachment
                  </>
                }
              </div>
              <input
                ref={attachmentUploadRef}
                type="file"
                style={loadingAttachment ? { ...styles.attachmentView, cursor: 'not-allowed' } : styles.attachmentView}
                disabled={loadingAttachment}
                onChange={onFileUpload}
                onClick={onInputChange}
              />
            </div>
          </div>
      
          {attachmentsSelected.length > 0 && attachmentsSelected.map((attachment) => (
            <div style={{ background: '#FFFFFF', border: "1px solid black", borderRadius: 4, display: 'flex', justifyContent: 'space-between', width: "100%" }}>
              <div
                css={css`*::-webkit-scrollbar { width: 0px; };`}
                style={{ display: 'flex', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', justifyContent: 'flex-start', alignItems: 'center', fontSize: 12 }}
              >
                <Icon src={ICONS.pdfIcon} height={18} width={18} style={{ marginRight: 6 }} />
                {extractFileName(attachment)}
              </div>
              <div style={{ background: '#EEEEEE', alignContent: 'center', padding: 8, cursor: 'pointer' }} onClick={() => onAttachmentDeleteClick(attachment)}>
                <Icon src={ICONS.deleteDarkFill} height={20} width={20} />
              </div>
            </div>
          ))}
      
          <CustomizedButton
            type={"secondary"}
            btnText={"Submit"}
            btnStyle={{ width: "100%" }}
            onClick={handleSubmit} 
            disabled={loadingAttachment || (attachmentsSelected?.length < 1 && inputValue?.trim()?.length < 1)}
          />
        </div>
      </Drawer>
      

    )
}
function commonStyle(isOpen, inputValue) {

    const styles = {
    pointer: css`
      cursor:pointer;
    `,
    instructionsContainer: css`
    font-size:14px;
    position: absolute;
    top:110px;
    width: 100%;
    height:100%;
    max-height:calc(100vh - 270px);
    overflow:auto; 
  `,
        title: css`
      color: #262626;
      text-align: center;
      font-family: "Objectivity";
      font-size: 14x;
      font-style: normal;
      font-weight: 500;
      line-height: 160%;
      margin-top: 16px;
    `,
        subtitle1: css`
      color: #262626CC;
      text-align: center;
      font-family: "Objectivity";
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      border-bottom: 1px solid #eee;
        padding: 16px 0px;
    `,
        bottomContainer: css`
        width: 100%;
        flex-shrink: 0;
        display:flex;
        bottom: 0;
        position: absolute;
        justify-content: space-evenly;
        align-items: center;
        border-top: 1px solid #eee;
        flex-direction: column;
        gap:10px;
        padding: 10px;
        margin-top: 20px;
    `,
        input: css`
        display: inline-flex;
        height: 40px;
        padding: 10px;
        align-items: center;
        flex-shrink: 0;
        background: #F9F9F9;
        border: 1px solid lightgray;
        border-radius: 4px;
        width:100%;
        height: 40px;
    `,
        message: css`
        padding: 16px;
        align-items: center;
        flex-shrink: 0;
        border-radius: 8px;
        background: #F9F9F9;
        margin: 16px;
        max-width: 300px;
        word-wrap: break-word; 
     `,
        closeButton: css`
        display: flex;
        height: 56px;
        padding: 16px 4px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: 8px 0px 0px 8px;
        background: #FFF;
        position: absolute;
        right: ${isOpen ? "368px" : "0px"};
        z-index:1500;
        transition-duration: 100;
        margin-top: 10px;
        width: max-content;
     `,
     attachmentView:{
        opacity: 0,
        width:'95%',
        top:10,
        left:20,
        height:'100%',
        position:'absolute',
        zIndex: 100,
        cursor: "pointer",
    }
    }
    return styles;
}
